export const en = {
  nav: {
    home: 'Home',
    all_events: 'All Events',
    gallery: 'Gallery',
    resources: "Resources",
    case_studies: "Case Studies",
    virtual_volunteering_tips: "Virtual Volunteering Tips",
    my_events: 'My Requests & Created Events',
    volunteer_activity: 'My Volunteering',
    impact: 'Impact',
    admin_dashboard: 'Admin Dashboard',
    help: 'Help',
    company_settings: 'Company Settings',
    account_settings: 'Account Settings',
    for_companies: "For Companies",
    for_nonprofits: "For Nonprofits",
    how_it_works: "How it works",
    features: "Features",
    stories: "Stories",
    features_integrations: "Integrations",
    features_reporting: "Reporting",
    features_nonprofit_network: "Nonprofit Network",
    features_shifts: "Event Management",
    log_in: "Log in",
    log_out: "Log out",
    greenshield: "Life as One GreenShield",
  }
}